import { request } from '@wix/da-shared-react/pkg/xhr';
import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { API_BASE_PATH } from '../../constants';
import { getProfileOwnerUser } from '../selectors/users';

import { runModuleInitActions } from './modules';

import {
  getModuleIdByModuleType,
  getModuleVersion,
} from '../selectors/modules';
import { ModuleType } from '../../types/modules';
import { SagaIterator } from 'redux-saga';
import {
  getProfileHeroCropArea,
  getProfileHeroDeviation,
} from '../selectors/profileHeroEditor';
import {
  saveProfileHero,
  deleteProfileHero,
  setIsRepositioningProfileHero,
} from '../actions/profileHeroEditor';
import { getSourceImageRatio } from '@wix/da-shared-react/pkg/DeviationViews/Dumbo/Image/_helpers';

function* save(data) {
  return yield call(request, {
    method: 'post',
    baseURL: API_BASE_PATH,
    url: `/module/cover_deviation/save`,
    data,
  });
}

export function* saveProfileHeroSaga(): SagaIterator {
  const moduleId = yield select(
    getModuleIdByModuleType,
    ModuleType.COVER_DEVIATION
  );
  const moduleVersion = yield select(getModuleVersion, moduleId);
  const { username } = yield select(getProfileOwnerUser);
  const version = moduleVersion;

  const deviation = yield select(getProfileHeroDeviation);
  const originalImageRatio = getSourceImageRatio(deviation);
  const cropArea = yield select(getProfileHeroCropArea);
  const cropAreaPapiParams = cropArea
    ? {
        image_width: cropArea.width,
        image_height: Math.round(cropArea.width / originalImageRatio),
        crop_x: cropArea.x,
        crop_y: cropArea.y,
        crop_width: cropArea.width,
        crop_height: cropArea.height,
      }
    : {};

  const response = yield call(save, {
    moduleid: moduleId,
    // Even though this expects a number and we're passing through the normalized
    // deviation id (which could be number | string), it should only ever receive
    // a deviation that production an id of type number
    deviationid: deviation.deviationId,
    ...cropAreaPapiParams,
    version,
    username,
  });

  if (response && response.moduleData) {
    yield call(runModuleInitActions, response);
    yield put(setIsRepositioningProfileHero(false));
  }
}

export function* deleteProfileHeroSaga() {
  const moduleId = yield select(
    getModuleIdByModuleType,
    ModuleType.COVER_DEVIATION
  );
  const version = yield select(getModuleVersion, moduleId);
  const { username } = yield select(getProfileOwnerUser);
  const response = yield call(save, {
    moduleid: moduleId,
    deviationid: 0,
    version,
    username,
  });

  if (response && response.moduleData) {
    yield call(runModuleInitActions, response);
  }
}

export default function* rootCoverDeviationSaga() {
  yield all([
    takeEvery(saveProfileHero, saveProfileHeroSaga),
    takeEvery(deleteProfileHero, deleteProfileHeroSaga),
  ]);
}
